import React, { FC, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Navigate, Routes, useNavigate, useParams, useLocation } from 'react-router-dom'
import {
  Container,
  HeadWrapper,
  InstanceName,
  NavWrapper,
} from './styles'
import {
  BackArrow,
  TopProgress,
  Tabs,
} from '../../../../components'
import { hypervisorService } from '../../../../api'
import { useUi } from '../../../../context/ui.context'
import { InstanceDot, InstanceHeadInfo, InstanceStatus } from '../../Instances/components/instance-page/styles'
import Overview from './overview'
import { usePageTitle } from '../../../../context/navigationContext'

const HypervisorPage: FC = () => {
  const [t] = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { hypervisorId } = useParams()
  const { viewAlert } = useUi()
  const [hypervisor, setHypervisor] = useState<any>(null)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  usePageTitle(hypervisor ? `${t("PAGE_TITLE_HYPERVISOR_DETAIL")}: ${hypervisor?.host_name}` : t("PAGE_TITLE_HYPERVISOR_DETAIL"))

  const getActiveTabFromPath = () => {
    const path = location.pathname.split('/').pop()
    return path || 'overview'
  }

  const [activeTab, setActiveTab] = useState<string>(getActiveTabFromPath())

  useEffect(() => {
    const currentTab = getActiveTabFromPath()
    setActiveTab(currentTab)
  }, [location.pathname])

  const _updateHypervisor = () => {
    if (hypervisorId) {
      hypervisorService.getHypervisorById(hypervisorId)
        .then((res) => {
          // memory_mb может прийти как массив, исправляем
          const data = res.data;
          if (Array.isArray(data.memory_mb)) {
            data.memory_mb = data.memory_mb[0];
          }
          setHypervisor(data)
          setPageLoading(false)
        })
        .catch((err) => {
          viewAlert({
            severity: 'error',
            message: err?.response?.data?.detail || t("ERROR_OCCURRED"),
          })
          navigate('/openstack/hypervisors')
          setPageLoading(false)
        })
    }
  }

  useEffect(() => {
    _updateHypervisor()
    const interval = setInterval(() => {
      _updateHypervisor()
    }, 10000)
    return () => {
      clearInterval(interval)
    }
  }, [hypervisorId])

  const tabs = [
    {
      title: t("OVERVIEW"),
      slug: 'overview',
      id: '1'
    },
  ]

  if (pageLoading) return <TopProgress loading={pageLoading} />

  return (
    <Container>
      <TopProgress loading={!pageLoading && false} />
      <BackArrow fallbackPath="/openstack/hypervisors" />
      <HeadWrapper>
        <InstanceName>
          {hypervisor?.host_name}
        </InstanceName>
      </HeadWrapper>
      <InstanceHeadInfo style={{ margin: "0px" }}>
        <InstanceDot active={hypervisor?.state === 'up'} />
        <InstanceStatus active={hypervisor?.state === 'up'}>
          {hypervisor?.state === 'up' ? t("UP") : t("DOWN")} & {hypervisor?.status === 'enabled' ? t("ENABLED") : t("DISABLED")}
        </InstanceStatus>
      </InstanceHeadInfo>
      <NavWrapper>
        <div>
          <Tabs
            tabs={tabs}
            size='display'
            location={activeTab}
            onChange={setActiveTab}
          />
        </div>
      </NavWrapper>
      <Routes>
        <Route path="/" element={<Navigate replace to="overview" />} />
        <Route path="*" element={<Navigate replace to="overview" />} />
        <Route path='/overview' element={<Overview hypervisor={hypervisor} />} />
      </Routes>
    </Container>
  )
}

export default HypervisorPage
